export enum TicketStatusType {
    Deactive = 0,
    Pending = 1,
    InProgress = 2,
    Complete = 3,
}